import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/esg/esgSix/esgSix.webp";

import card from "../..//../assets/img/esg/esgSix/card.webp";

function EsgSix() {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);
  const [startCounting, setStartCounting] = useState(false);

  useEffect(() => {
    if (startCounting) {
      const targetCount = 11000;
      const duration = 1000; // Duração em milissegundos
      const increment = targetCount / duration;

      const interval = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount + increment >= targetCount) {
            clearInterval(interval);
            return targetCount;
          }
          return prevCount + increment;
        });
      }); // Intervalo de 10 milissegundos (ajuste conforme necessário)

      return () => clearInterval(interval);
    }
  }, [startCounting]);

  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setStartCounting(true);
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="esgSix" className={`esgSix ${isVisible ? "visible" : ""}`}>
        <img className={`sixImg ${isVisible ? "visible" : ""}`} src={img1} alt="" />
        <div className="esgSixTitle">
          <h1 className={` ${isVisible ? "visible" : ""}`}>
            {t("esg_six_title")}
          </h1>
          <p className={` ${isVisible ? "visible" : ""}`}>
            {t("esg_six_text")}
          </p>
          <div className="tampinhas">
            <img
              className={` ${isVisible ? "visible" : ""}`}
              src={card}
              alt=""
              width={"400"}
            />
            <p className={` ${isVisible ? "visible" : ""}`}>
              <span>+ {count.toLocaleString()}</span>
              <br />
              {t("esg_six_count_label")}
            </p>
          </div>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default EsgSix;
